import { defineMessages } from 'react-intl';

const messages = defineMessages({
  changeHeadOfHousehold: {
    id: 'App.Household.ChangeHeadOfHousehold.ChangeHeadOfHousehold',
    defaultMessage: 'Change Head of Household',
  },
  noOtherAdultAvailableTooltip: {
    id: 'App.Household.ChangeHeadOfHousehold.NoOtherAdultAvailableTooltip',
    defaultMessage:
      'There is not another Adult available to become Head of Household.',
  },
  openCertsTooltip: {
    id: 'App.Household.ChangeHeadOfHousehold.OpenCertsTooltip',
    defaultMessage:
      'There is an open certification for this household. In order to ' +
      'change the Head of Household, you will need to cancel or complete ' +
      'the open certification.',
  },
  modalSubtitle: {
    id: 'App.Household.ChangeHeadOfHousehold.ModalSubtitle',
    defaultMessage: 'Choose another adult to become the Head of Household.',
  },
  currentHeadOfHousehold: {
    id: 'App.Household.ChangeHeadOfHousehold.CurrentHeadOfHousehold',
    defaultMessage: 'Current Head of Household',
  },
  relationshipRequiredWarning: {
    id: 'App.Household.ChangeHeadOfHousehold.RelationshipRequiredWarning',
    defaultMessage:
      'Before you can save your changes, you must specify the ' +
      'Relationship(s) for the former Head of Household.',
  },
  relation: {
    id: 'App.Household.ChangeHeadOfHousehold.Relation',
    defaultMessage: 'Relation',
  },
  affordableRelationship: {
    id: 'App.Household.ChangeHeadOfHousehold.AffordableRelationship',
    defaultMessage: 'Affordable Relationship',
  },
  confirmChangeTitle: {
    id: 'App.Household.ChangeHeadOfHousehold.ConfirmChangeTitle',
    defaultMessage: 'Change Head of Household',
  },
  confirmChangeDescription: {
    id: 'App.Household.ChangeHeadOfHousehold.ConfirmChangeDescription',
    defaultMessage:
      'You are changing the Head of Household from {formerName} to ' +
      '{newName}. This will go into effect immediately. Are you sure you ' +
      'want to proceed?',
  },
  changeSuccess: {
    id: 'App.Household.ChangeHeadOfHousehold.ChangeSuccess',
    defaultMessage: 'Head of Household updated successfully.',
  },
});

export default messages;
